export interface ICashierWidgetsEligibilityDetails {
    isABEligible: boolean;
    isNtsEligible: boolean;
    ineligibleReason: string;
    errorCode: number;
    errorMessage: string;
    featureName?: string;
    testID?: number
    testGroup?: string;
}

export function createDefaultCashierWidgetEligibility(): ICashierWidgetsEligibilityDetails {
    return {
        isABEligible: false,
        isNtsEligible: false,
        errorCode: 0,
        errorMessage: "",
        ineligibleReason: ""
    };
}